let shopReLoader = function() {
    this.timer = null;
    this.changedControls = [];
    this.errorControls = [];
};

shopReLoader.init = function () {
    //this holds a record of all the controls that have been changed and need posting
    this.changedControls = [];
    //this holds a record of controls currently in error
    this.errorControls = [];
    //this is the path to the server post
    this.postPath = $('#checkout-form').data('ajax-path');

    this.continueButton = $('button[data-action=\'continueToCheckout\']');
    this.originalButtonText = this.continueButton.html();
    
    //on each keyup on any of the controls with this class, set a timer, reset each time to stop loads of server posts and when a timer 
    //eventually executes call the function to push the data
    $(document).on('input', '.reloadOnChange',  function(e) {

        //stop the user being able to "continue"
        this.continueButton.html('Updating Basket Please Wait...');
        this.continueButton.prop('disabled', true);

        //add the control to the array (if not there already)
        if (!this.changedControls.includes(e.target.name))
            this.changedControls.push(e.target.name);

        //clear the current timer and set a new one
        clearTimeout(this.timer);
        this.timer = setTimeout(this.tryPost.bind(this), 1000);
    }.bind(this));

};


shopReLoader.tryPost = function() {
    //for each control that has been changed
    this.changedControls.forEach(function(changedControl, i) 
    {
        var inputType = (changedControl.indexOf('sNote') > -1) ? 'textarea' : (changedControl.indexOf('variant') > -1 ? 'select' : 'input');
        var selector = inputType + '[name=\'' + changedControl + '\']';
        var control = $(selector);
        var controlValue = control.val();
        console.log(selector);
        console.log(control);
        console.log(controlValue);
        
        $.when(
            //would have used a $.post call but in trying to fix a bug with context (turned out to not be about that), I changed it to this format
            //no point in changing it back
            $.ajax({
                type: 'POST',
                url: this.postPath,
                data: {
                  //send the name of the control and new value to the server
                  name: changedControl,
                  value: controlValue
                },
                context: this,
                success: 
                    function(returnData) {
                        if (returnData)
                        {
                            if (returnData.success)
                            {
                                if (returnData.data && returnData.data.messageTarget)
                                {
                                    //update the line price and basket price and make both "flash" by adding classes
                                    var priceSelector = '#linePrice_' + returnData.data.messageTarget;
                                    $(priceSelector).html(returnData.data.lineItemTotal).removeClass('flashChange').removeClass('undoFlash').addClass('flashChange');
                                    $('#basket-total').html(returnData.data.basketTotal).removeClass('flashChange').removeClass('undoFlash').addClass('flashChange');
                                    //this add a second class with the transition back to white
                                    setTimeout(
                                        function() { 
                                            $(priceSelector).addClass('undoFlash');
                                            $('#basket-total').addClass('undoFlash');
                                        }, 300
                                    );
                                    
                                    //clear the associated error message as this was successful
                                    var errorSelector = '#serverErrorMessage_' + returnData.data.messageTarget;
                                    $(errorSelector).html('');
                                    $(errorSelector).hide();

                                    //remove the control from the error list
                                    if (this.errorControls.includes(this.changedControls[i]))
                                        this.errorControls = this.errorControls.filter(function(item) { return item !== this.changedControls[i] }.bind(this));
                                
                                }

                                if (this.errorControls.length === 0)
                                {
                                    //no errors - so let the user continue
                                    this.continueButton.html(this.originalButtonText);
                                    this.continueButton.prop('disabled', false);
                                }
                                else
                                {
                                    //errors still remain, so leave the button disabled and show the "please correct" text
                                    this.continueButton.html('Please Correct the Form');
                                }
                            }
                            else
                            {
                                //the call was not successful, so show the error in the appropriate place
                                this.errorControls.push(this.changedControls[i]);
                                this.displayErrorMessage(returnData.message, returnData.messageTarget);
                            }
                        }
                        else
                        {
                            //if no data, then probably a 500 or similar...
                            this.displayErrorMessage('Sorry, something has gone wrong with the auto-update - please use the manual Update Basket button below before checkout.', null);
                        }
                    }
                })
            ).done(function() { 
                //remove the control from the controls needing to be posted
                this.changedControls = this.changedControls.filter(function(item) { return item !== changedControl }.bind(this)); } 
            );
    }.bind(this));
};

shopReLoader.displayErrorMessage = function(message, target) {
    this.continueButton.html('Please Correct the Form');

    target = '#serverErrorMessage_' + (target ? target : 'All');
    
    $(target).html('Error updating your details: ' + message);
    $(target).show();
};

export default shopReLoader;